import { deserialize as fcDeserialize, deserializeStream as fcDeserializeStream, deserializeFiltered as fcDeserializeFiltered, serialize as fcSerialize } from "./geojson/featurecollection.js";
/**
 * Serialize GeoJSON to FlatGeobuf
 * @param geojson GeoJSON object to serialize
 */
export function serialize(geojson) {
    const bytes = fcSerialize(geojson);
    return bytes;
}
/**
 * Deserialize FlatGeobuf into GeoJSON
 * @param input Input byte array, stream or string
 * @param rect Filter rectangle
 * @param headerMetaFn Callback that will recieve header metadata when available
 */
export function deserialize(input, rect, headerMetaFn) {
    if (input instanceof Uint8Array)
        return fcDeserialize(input, headerMetaFn);
    else if (input instanceof ReadableStream)
        return fcDeserializeStream(input, headerMetaFn);
    return fcDeserializeFiltered(input, rect, headerMetaFn);
}
